import { Injectable } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { IPodesavanjaArhivskeDokumentacijeDto } from "@kodit/core/data-api";
import { FormBuilderTypeSafe, FormGroupTypeSafe } from "angular-typesafe-reactive-forms-helper";

@Injectable({
  providedIn: 'root',
})

export class PodesavanjaArhivskeDokumentacijeService {

  constructor(
    private _fb: FormBuilderTypeSafe
  ) {}

  public GetPodesavanjaArhivskeDokumentacijeFormGroup(
    model?: IPodesavanjaArhivskeDokumentacijeDto
  ): FormGroupTypeSafe<IPodesavanjaArhivskeDokumentacijeDto> {
    return this._fb.group<IPodesavanjaArhivskeDokumentacijeDto>({
      arhiv: new FormControl(model?.arhiv, [Validators.required]),
      postanskiBrojArhiva: new FormControl(model?.postanskiBrojArhiva, [Validators.required]),
      adresaArhiva: new FormControl(model?.adresaArhiva, [Validators.required]),
      gradArhiva: new FormControl(model?.gradArhiva, [Validators.required]),
      kontaktOsoba: new FormControl(model?.kontaktOsoba, [Validators.required]),
      mail: new FormControl(model?.mail, [Validators.required]),
      brojTelefona: new FormControl(model?.brojTelefona, [Validators.required]),
      jeCirilica: new FormControl(model?.jeCirilica)
    });
  }
}
